import { render } from "./QueryView.vue?vue&type=template&id=9cd5ad5e&scoped=true"
import script from "./QueryView.vue?vue&type=script&lang=js"
export * from "./QueryView.vue?vue&type=script&lang=js"

import "./QueryView.vue?vue&type=style&index=0&id=9cd5ad5e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd5ad5e"]])

export default __exports__